//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HeaderButton from './HeaderButton'
import GlossaryIcon from '~sdp-components/Icons/GlossaryIcon'

export default {
  components: {
    HeaderButton,
    GlossaryIcon
  },
  props: {
    bannerMessage: {
      type: String,
      required: false,
      default: undefined
    }
  }
}
